import { Component, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { ReplyAbstractComponent } from '../reply-abstract.component';
import { BalanceHistoryService } from '../../../../core/account/balance-history.service';
import { SocketService } from '../../../../core/socket.service';
import { DomSanitizer } from '@angular/platform-browser';

const MersenneTwister = require('mersennetwister');

@Component({
  selector: 'app-reply-treasure-hunt',
  template: `
    <div class="treasure-window">
      <div class="overflow-content">
        <div *ngFor="let row of rows; let rowIndex = index" class="row">
          <div class="row-label">{{ rowsLength - rowIndex }}</div>
          <app-treasure-reply-item
            *ngFor="let col of columns; let columnIndex = index"
            [openCase]="luckyNumbers[rowIndex][columnIndex]"
            [row]="rowsLength - rowIndex - 1"
          ></app-treasure-reply-item>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./reply-treasure-hunt.component.scss'],
})
export class ReplyTreasureHuntComponent extends ReplyAbstractComponent {
  readonly rowsLength: number = 10;
  readonly columnsLength: number = 3;

  rows = [];
  columns = [];

  luckyNumbers: number[][] = [];

  constructor(protected socket: SocketService, protected balanceHistory: BalanceHistoryService) {
    super(socket, balanceHistory);
  }

  private generateLuckyNumbers() {
    const tempLuckyNumbers: number[][] = [];
    this.rows = Array(this.rowsLength).fill(0);
    this.columns = Array(this.columnsLength).fill(0);

    for (let i = 0; i < this.rowsLength; i++) {
      const row: number[] = this.generateRandomNumber(this.playerSeed, this.serverSeed, i);
      tempLuckyNumbers.push(row);
    }

    this.luckyNumbers = tempLuckyNumbers;
  }

  // 0 - win, 1 - key, 2 -lose
  private generateRandomNumber(
    clientSeed: string,
    serverSeed: string,
    nonce: number,
    wins: number = 2,
    bombs: number = 1,
    keys: number = 0
  ): Array<number> {
    clientSeed = clientSeed.replace('0x', '');
    serverSeed = serverSeed.replace('0x', '');

    const clSeedSplitted = clientSeed.match(/.{1,6}/g);
    const srvSeedSplitted = serverSeed.match(/.{1,6}/g);
    const seedsCombined = clSeedSplitted.concat(srvSeedSplitted).concat(String(nonce));

    for (let i = 0; i < seedsCombined.length; i++) {
      seedsCombined[i.toString()] = parseInt(seedsCombined[i], 16);
    }

    const mt = new MersenneTwister();
    mt.seedArray(seedsCombined);

    const w = this.fillArray(wins, 0);
    const k = this.fillArray(keys, 1);
    const b = this.fillArray(bombs, 2);

    const shuffledDeck = [...w, ...b, ...k];

    for (let i = shuffledDeck.length - 1; i > 0; i -= 1) {
      const j = Math.floor(mt.real() * (i + 1));
      const temp = shuffledDeck[i];
      shuffledDeck[i] = shuffledDeck[j];
      shuffledDeck[j] = temp;
    }
    return shuffledDeck;
  }

  private fillArray(times, value) {
    let arr = [];
    for (let i = 0; i < times; i += 1) {
      arr.push(value);
    }
    return arr;
  }

  // specified game
  protected initialize(data: any) {
    if (data) {
      if (data.game !== 'treasure-hunt') {
        this._error = true;
        return;
      }
      // this.data = data.gameData;
      this._loading = false;
    }

    this.generateGame();
  }

  // not specified game
  protected generateGame() {
    this.generateLuckyNumbers();
    this._loading = false;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-treasure/reply-treasure-hunt.component.ts